import {
  Box,
  Card,
  CardActionArea,
  Typography,
} from '@mui/material'

type Props = {
  reward?: any
  onClick?: (reward: any) => void
  cardSx?: any
}

export default function CorporateRewardCard({
  reward,
  onClick,
  cardSx,
}: Props) {
  const isPointsOnly = reward?.type === 'only_points'
  const imageUrl = reward?.images?.[2]?.url || '/default-points-icon.png'
  const name = reward?.name || reward?.details?.name || 'Points Reward'
  const brand = reward?.brand || 'Points'
  const amount = reward?.amount

  return (
    <Card
      sx={{
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        height: 'auto',
        backgroundColor: 'common.white',
        boxShadow: 'none',
        border: 'none',
        aspectRatio: '3/4',
        ...cardSx,
      }}
    >
      <CardActionArea
        onClick={() => onClick?.(reward)}
        sx={{
          height: '100%',
          width: '100%',
          position: 'relative',
        }}
      >
        {isPointsOnly ? (
          <>
            <Box
              component="div"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}
            />

            <Box
              sx={{
                position: 'relative',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'flex-start',
                p: 2,
                color: 'common.white',
              }}
            >
              <Typography
                sx={{
                  fontSize: '1.5rem',
                  fontWeight: 700,
                  textShadow: '0 1px 3px rgba(0,0,0,0.8)',
                  lineHeight: 1,
                  mb: 0.5,
                }}
              >
                {amount} Points
              </Typography>

              <Typography
                sx={{
                  fontSize: '1rem',
                  fontWeight: 600,
                  textShadow: '0 1px 2px rgba(0,0,0,0.8)',
                }}
              >
                {name}
              </Typography>
            </Box>
          </>
        ) : (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              p: 1,
            }}
          >
            <Box
              component="img"
              src={imageUrl}
              alt={name}
              sx={{
                width: '100%',
                maxHeight: '60%',
                objectFit: 'contain',
              }}
            />
            <Typography
              variant="body2"
              fontWeight={500}
              mt={1}
              textAlign="center"
              sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
            >
              {name}
            </Typography>
            <Typography variant="body1" fontWeight={500} textAlign="center">
              {brand}
            </Typography>
          </Box>
        )}
      </CardActionArea>
    </Card>
  );
}

